export const measurements = {
  mobi: {
    headerHeight: '5.6rem',
    bottomTabsHeight: '5rem',
    maxWidth: '80rem',
    minWidth: '32rem',
  },
} as const

export const pageContentHeight = `calc(100vh - ${measurements.mobi.bottomTabsHeight} - ${measurements.mobi.headerHeight})`
